import styled from 'styled-components';
import { OfferStyled } from '../OfferStyled';

export const OfferStyledOVGB = styled(OfferStyled)`
    .offer {
    }
`;
